import React from 'react';

export type SuggestionType = 'bad' | 'good' | 'info' | 'warning';

export type Suggestion = {
    value: string;
    type: SuggestionType;
};

export type Suggestions = {
    [key: string]: {
        [reason: string]: Suggestion[];
    };
};
const FormSuggestion = ({ suggestions }: { suggestions: { [reason: string]: Suggestion[] } }) => {
    if (!suggestions || Object.keys(suggestions).length === 0) return null;

    return (
        <>
            {Object.entries(suggestions).map(([reason, suggestionList]) => (
                <div key={reason}>
                    {suggestionList.map((suggestion, index) => {
                        let icon = '';
                        let classNames = '';

                        switch (suggestion.type) {
                            case 'bad':
                                icon = '✖';
                                classNames = 'invalid-feedback';
                                break;
                            case 'good':
                                icon = '✔';
                                classNames = 'valid-feedback d-block';
                                break;
                            case 'info':
                                icon = 'ℹ️';
                                break;
                            case 'warning':
                                icon = '⚠️';
                                classNames = 'text-warning';
                                break;
                            default:
                                icon = '';
                        }

                        classNames += ' font-14';

                        return (
                            <div key={index} className={classNames}>
                                <strong>
                                    {icon} {suggestion.value}
                                </strong>
                            </div>
                        );
                    })}
                </div>
            ))}
        </>
    );
};

export default FormSuggestion;
